// App has this permissions, it's required to handle the app routing's
export enum APP_PERMISSION {
	request = 'request',
	approve = 'approve',
}
